var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 10C10.9477 10 10.5 10.4477 10.5 11V20C10.5 20.5523 10.9477 21 11.5 21H20.5C21.0523 21 21.5 20.5523 21.5 20V11C21.5 10.4477 21.0523 10 20.5 10H11.5ZM8.5 11C8.5 9.34315 9.84315 8 11.5 8H20.5C22.1569 8 23.5 9.34315 23.5 11V20C23.5 21.6569 22.1569 23 20.5 23H11.5C9.84315 23 8.5 21.6569 8.5 20V11Z",
    fill: "#F1F2F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 3C4.23478 3 3.98043 3.10536 3.79289 3.29289C3.60536 3.48043 3.5 3.73478 3.5 4V13C3.5 13.2652 3.60536 13.5196 3.79289 13.7071C3.98043 13.8946 4.23478 14 4.5 14H5.5C6.05228 14 6.5 14.4477 6.5 15C6.5 15.5523 6.05228 16 5.5 16H4.5C3.70435 16 2.94129 15.6839 2.37868 15.1213C1.81607 14.5587 1.5 13.7956 1.5 13V4C1.5 3.20435 1.81607 2.44129 2.37868 1.87868C2.94129 1.31607 3.70435 1 4.5 1H13.5C14.2956 1 15.0587 1.31607 15.6213 1.87868C16.1839 2.44129 16.5 3.20435 16.5 4V5C16.5 5.55228 16.0523 6 15.5 6C14.9477 6 14.5 5.55228 14.5 5V4C14.5 3.73478 14.3946 3.48043 14.2071 3.29289C14.0196 3.10536 13.7652 3 13.5 3H4.5Z",
    fill: "#F1F2F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.62718b4d97a6c52b36ce3240f3faa0fe.svg";
export { ForwardRef as ReactComponent };